import { useState } from "react";
import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { studentsData } from "../../assets/studentsData"
import { BUTTON_STYLE } from "../../assets/constants";
import SimpleAlert from "../../theme/alerts/SimpleAlert";
export default function StudentProfile() {

    const [student, setStudent] = useState(null);
    const [openModal, setOpenModal] = useState(false);

    const location = useLocation();
    const { state } = location;
    console.log(state);

    useEffect(() => {
        const data = studentsData.filter(
            (student, index) => student.studentId === state.id
        )[0];
        console.log(data);
        setStudent(data);
    }, [])

    const hendleUpdateProfile = () => {
        SimpleAlert("Success", "Student Records Successfully updated", 'success ', 1500)
        SimpleAlert("Error", "Error occured while updating student records", 'error', 1500)
    }
    const handleUpdateMarks = () => {
        SimpleAlert("Success", "Student Marks Successfully deleted", 'success ', 1500)
        SimpleAlert("Error", "Error occured while updating student marks", 'error', 1500)
    }
    const handleDelete = () => {
        SimpleAlert("Success", "Student Records Successfully deleted", 'success ', 1500)
        SimpleAlert("Error", "Error occured while deleteing student records", 'error', 1500)
    }
    return (
        <>
            {/* <Form title={`${student?.name} Profile`} data={student} /> */}

            <div className="sm:flex flex-row items-center justify-between">
                <div className="flex flex-row items-center space-x-5">
                    <img
                        src={`https://api.dicebear.com/6.x/identicon/svg?seed=${student?.userName}`}
                        alt="avatar"
                        className="w-20 h-20 rounded-full border-[2px] border-gray-500 mt-2"
                    />
                    <div className="space-y-2">
                        <div className="flex  items-center space-x-3">
                            <span className="font-medium text-xl md:text-4xl">Name</span> <h1 className="text-xl md:text-4xl font-normal">{student?.name}</h1>
                        </div>
                        <div className="flex  items-center space-x-3">
                            <span className="font-medium text-md md:text-xl">ID:</span> <h1 className="text-md md:text-xl font-medium">{student?.studentId}</h1>
                        </div>
                    </div>
                </div>

                <div className="flex justify-end mt-2">
                    <button
                        className={`${BUTTON_STYLE} bg-red-600 hover:bg-red-500 font-semibold sm:text-lg px-3`}
                        onClick={handleDelete}
                    >
                        Delete Student
                    </button>
                </div>
            </div>
            <hr class="w-100 h-1 mx-auto my-4 bg-gray-100 border-0 rounded md:my-5 dark:bg-gray-700" />
            <div>
                <div>
                    <div className="space-y-5">
                        <div className="flex  items-center space-x-3">
                            <span className="font-medium md:text-2xl">Username:</span> <h1 className="text-md md:text-2xl md:font-normal text-gray-800">{student?.userName}</h1>
                        </div>
                        <div className="flex  items-center space-x-3">
                            <span className="font-medium md:text-2xl">Name:</span> <h1 className="text-md md:text-2xl md:font-normal text-gray-800">{student?.email}</h1>
                        </div>
                        <div className="flex  items-center space-x-3">
                            <span className="font-medium md:text-2xl">Contact:</span> <h1 className="text-md md:text-2xl md:font-normal text-gray-800">{student?.contact}</h1>
                        </div>
                        <div className="flex  items-center space-x-3">
                            <span className="font-medium md:text-2xl">Date of Birth:</span> <h1 className="text-md md:text-2xl md:font-normal text-gray-800">{student?.birthDate}</h1>
                        </div>
                        <div className="flex  items-center space-x-3">
                            <span className="font-medium md:text-2xl">Address:</span> <h1 className="text-md md:text-2xl md:font-normal text-gray-800">{student?.address}</h1>
                        </div>

                    </div>
                    <div className="flex justify-end mt-2">
                        <button
                            className={`${BUTTON_STYLE} font-semibold sm:text-lg px-3`}
                            onClick={hendleUpdateProfile}
                        >
                            Update Profile
                        </button>
                    </div>
                </div>
                <div class="inline-flex items-center justify-center w-full">
                    <hr class="w-full h-1 my-8 border-0 rounded bg-gray-700" />
                    <div class="absolute px-4  bg-slate-100 font-medium text-lg md:text-xl uppercase ">
                        Marks
                    </div>
                </div>
                <div className="">
                    <div className="space-y-2">
                        <div className="flex  items-center space-x-3">
                            <span className="font-medium md:text-2xl">Obtained Marks:</span> <h1 className="text-md md:text-2xl md:font-normal text-gray-800">{80}</h1>
                        </div>
                        <div className="flex  items-center space-x-3">
                            <span className="font-medium md:text-2xl">Total Marks:</span> <h1 className="text-md md:text-2xl md:font-normal text-gray-800">{120}</h1>
                        </div>
                        <div className="flex  items-center space-x-3">
                            <span className="font-medium md:text-2xl">Percentage:</span> <h1 className="text-md md:text-2xl md:font-normal text-gray-800">{66.66}%</h1>
                        </div>
                    </div>
                    <div className="flex justify-end mt-2">
                        <button
                            className={`${BUTTON_STYLE} font-semibold sm:text-lg px-3`}
                            onClick={handleUpdateMarks}
                        >
                            Update Mark
                        </button>
                    </div>
                </div>
                {/* {openModal && (
                    <Modal
                        openModal={openModal}
                        setOpenModal={setOpenModal}
                        postId={user}
                    />
                )} */}
            </div>
        </>
    )

}